(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["luvindow-home-runtime-v8"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const instances = new Map();
  function createProjectCarousel(root, getLanguage, listen, cleanup) {
  const noop = { refreshLanguage() {} };
  const viewport = root?.querySelector("[data-project-viewport]");
  const slides = viewport ? Array.from(viewport.querySelectorAll("[data-project-slide]")) : [];
  if (!viewport || !slides.length) return noop;

  const view = root.ownerDocument.defaultView;
  const previous = root.querySelector("[data-project-prev]");
  const next = root.querySelector("[data-project-next]");
  const status = root.querySelector("[data-project-status]");
  const selectors = slides.map((slide) => slide.querySelector("[data-project-select]"));
  let selected = 0;
  let pending = null;
  let settleTimer = 0;
  let resizeFrame = 0;
  let geometryKey = "";
  let pointerOrigin = null;
  let suppressPreviewClickUntil = 0;

  const language = () => typeof getLanguage === "function" && getLanguage() === "zh" ? "zh" : "en";
  const clamp = (index) => Math.max(0, Math.min(slides.length - 1, index));

  function geometry() {
    const viewportRect = viewport.getBoundingClientRect();
    const maximum = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    const inset = parseFloat(view.getComputedStyle(viewport).paddingLeft) || 0;
    return slides.map((slide) => {
      const left = slide.getBoundingClientRect().left - viewportRect.left - viewport.clientLeft + viewport.scrollLeft - inset;
      return Math.max(0, Math.min(maximum, left));
    });
  }

  function nearestIndex() {
    const positions = geometry();
    return positions.reduce((nearest, position, index) =>
      Math.abs(position - viewport.scrollLeft) < Math.abs(positions[nearest] - viewport.scrollLeft) ? index : nearest, 0);
  }

  function updatePresentation() {
    const isChinese = language() === "zh";
    const suffix = isChinese ? "ariaZh" : "ariaEn";
    root.setAttribute("aria-roledescription", isChinese ? "轮播" : "carousel");
    slides.forEach((slide, index) => {
      const distance = index - selected;
      slide.dataset.projectPosition = distance === 0 ? "current" : distance === -1 ? "previous" : distance === 1 ? "next" : distance < 0 ? "past" : "future";
      slide.setAttribute("aria-roledescription", isChinese ? "幻灯片" : "slide");
      if (index === selected) slide.setAttribute("aria-current", "true");
      else slide.removeAttribute("aria-current");
      slide.setAttribute('aria-label', isChinese ? `项目 ${index + 1}，共 ${slides.length} 个` : `Project ${index + 1} of ${slides.length}`);
      slide.querySelectorAll('a[href]').forEach(link => link.tabIndex = distance === 0 ? 0 : -1);
      const selector = selectors[index];
      if (selector) {
        const wasFocused = root.ownerDocument.activeElement === selector;
        selector.hidden = Math.abs(distance) !== 1;
        const title = slide.querySelector(`[data-copy="${isChinese ? "zh" : "en"}"]`)?.textContent || "";
        selector.setAttribute("aria-label", isChinese
          ? `${distance < 0 ? "上一个项目" : "下一个项目"}：${title}`
          : `${distance < 0 ? "Previous project" : "Next project"}: ${title}`);
        if (selector.hidden && wasFocused) viewport.focus({ preventScroll: true });
      }
    });
    if (previous) {
      previous.disabled = selected === 0;
      previous.setAttribute("aria-label", isChinese ? "上一个项目" : "Previous project");
    }
    if (next) {
      next.disabled = selected === slides.length - 1;
      next.setAttribute("aria-label", isChinese ? "下一个项目" : "Next project");
    }
    viewport.setAttribute("aria-label", isChinese
      ? "项目画廊。使用左右方向键浏览，Home 和 End 键跳到首个和最后一个项目。"
      : "Project gallery. Use Left and Right arrow keys to browse, Home and End for the first and last projects.");
    const announcement = slides[selected].dataset[suffix] || (isChinese
      ? `项目 ${selected + 1}，共 ${slides.length} 个`
      : `Project ${selected + 1} of ${slides.length}`);
    if (status && status.textContent !== announcement) status.textContent = announcement;
  }

  function settle() {
    view.clearTimeout(settleTimer);
    settleTimer = 0;
    pending = null;
    selected = nearestIndex();
    updatePresentation();
  }

  function scheduleSettle() {
    view.clearTimeout(settleTimer);
    settleTimer = view.setTimeout(settle, 160);
  }

  function navigate(index) {
    const target = clamp(index);
    if (target === selected && pending === null) return;
    selected = target;
    pending = target;
    view.clearTimeout(settleTimer);
    updatePresentation();
    const reducedMotion = view.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    viewport.scrollTo({ left: geometry()[target], behavior: reducedMotion ? "instant" : "smooth" });
    if (Math.abs(viewport.scrollLeft - geometry()[target]) < 1) scheduleSettle();
  }

  function interruptPending() {
    if (pending === null) return;
    pending = null;
    selected = nearestIndex();
    updatePresentation();
  }

  listen(previous, "click", () => navigate((pending ?? selected) - 1));
  listen(next, "click", () => navigate((pending ?? selected) + 1));
  selectors.forEach((selector, index) => listen(selector, "click", () => {
    if (Date.now() >= suppressPreviewClickUntil && !selector.hidden && Math.abs(index - selected) === 1) navigate(index);
  }));
  listen(viewport, "scroll", scheduleSettle, { passive: true });
  listen(viewport, "scrollend", settle);
  listen(viewport, "wheel", interruptPending, { passive: true });
  listen(viewport, "touchstart", (event) => {
    if (!event.target.closest("[data-project-select]")) interruptPending();
  }, { passive: true });
  listen(viewport, "pointerdown", (event) => {
    const preview = event.target.closest("[data-project-select]");
    pointerOrigin = { x: event.clientX, y: event.clientY, scroll: viewport.scrollLeft, moved: false, previewDuringAnimation: Boolean(preview && pending !== null) };
    if (event.pointerType === "mouse" && preview) event.preventDefault();
    if (!preview) interruptPending();
  });
  listen(viewport, "pointermove", (event) => {
    if (pointerOrigin && (Math.abs(event.clientX - pointerOrigin.x) > 8 || Math.abs(event.clientY - pointerOrigin.y) > 8)) {
      pointerOrigin.moved = true;
      suppressPreviewClickUntil = Date.now() + 400;
    }
  }, { passive: true });
  function finishPointer(event) {
    if (pointerOrigin && (pointerOrigin.moved || event.type === "pointercancel" || (!pointerOrigin.previewDuringAnimation && Math.abs(viewport.scrollLeft - pointerOrigin.scroll) > 8))) {
      suppressPreviewClickUntil = Date.now() + 400;
    }
    pointerOrigin = null;
  }
  listen(viewport, "pointerup", finishPointer, { passive: true });
  listen(viewport, "pointercancel", finishPointer, { passive: true });
  listen(viewport, "keydown", (event) => {
    if (event.target !== viewport || event.altKey || event.ctrlKey || event.metaKey || event.isComposing) return;
    const current = pending ?? selected;
    const targets = { ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: slides.length - 1 };
    if (!Object.prototype.hasOwnProperty.call(targets, event.key)) return;
    event.preventDefault();
    navigate(targets[event.key]);
  });

  function resize() {
    if (resizeFrame) return;
    resizeFrame = view.requestAnimationFrame(() => {
      resizeFrame = 0;
      const positions = geometry();
      const nextKey = `${viewport.clientWidth}:${viewport.scrollWidth}:${positions.join(",")}`;
      if (nextKey === geometryKey) return;
      geometryKey = nextKey;
      const target = pending ?? selected;
      pending = null;
      view.clearTimeout(settleTimer);
      viewport.scrollTo({ left: positions[target], behavior: "instant" });
      selected = target;
      updatePresentation();
    });
  }

  selected = nearestIndex();
  geometryKey = `${viewport.clientWidth}:${viewport.scrollWidth}:${geometry().join(",")}`;
  updatePresentation();
  if (typeof view.ResizeObserver === "function") {
    const observer = new view.ResizeObserver(resize);
    observer.observe(viewport);
    cleanup.push(() => observer.disconnect());
    slides.forEach((slide) => observer.observe(slide));
  } else {
    listen(view, "resize", resize);
  }

  cleanup.push(() => { view.clearTimeout(settleTimer); view.cancelAnimationFrame(resizeFrame); });
  return { refreshLanguage: updatePresentation, navigate };
}



function createHelpCards(scope, listen, cleanup) {
  const group = scope.querySelector('[data-help-cards]');
  if (!group) return;
  const cards = Array.from(group.querySelectorAll('[data-help-card]'));
  const toggles = cards.map(card => card.querySelector('.help-card-toggle'));
  const expandedRegions = cards.map(card => Array.from(card.querySelectorAll('.help-card-details, [data-help-expanded-only]')));
  const defaultIndex = Math.min(1, cards.length - 1);
  if (!cards.length) return;
  let hoveredIndex = null;

  function focusedIndex() {
    return cards.findIndex(card => card.contains(document.activeElement));
  }

  function activate(index, engaged = true) {
    if (!cards[index]) return;
    group.dataset.mode = engaged ? 'engaged' : 'rest';
    cards.forEach((card, i) => {
      const selected = i === index;
      card.classList.toggle('is-active', selected);
      toggles[i].setAttribute('aria-expanded', String(selected));
      expandedRegions[i].forEach(region => {
        region.setAttribute('aria-hidden', String(!selected));
        region.toggleAttribute('inert', !selected);
      });
    });
  }

  function revealOnSmallScreen(card) {
    if (!window.matchMedia('(max-width: 800px)').matches) return;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    card.scrollIntoView({block:'nearest', inline:'center', behavior});
  }

  cards.forEach((card, index) => {
    listen(card, 'pointerenter', event => {
      if (event.pointerType === 'touch') return;
      hoveredIndex = index;
      const focused = focusedIndex();
      if (focused !== -1 && expandedRegions[focused].some(region => region.contains(document.activeElement))) return;
      activate(index);
    });
    listen(toggles[index], 'click', () => {
      activate(index);
      revealOnSmallScreen(card);
    });
    listen(card, 'focusin', () => activate(index));
    listen(toggles[index], 'keydown', event => {
      let next = null;
      if (event.key === 'ArrowRight') next = Math.min(cards.length - 1, index + 1);
      if (event.key === 'ArrowLeft') next = Math.max(0, index - 1);
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = cards.length - 1;
      if (next === null) return;
      event.preventDefault();
      toggles[next].focus({preventScroll:true});
      revealOnSmallScreen(cards[next]);
    });
  });

  listen(group, 'pointerleave', () => {
    hoveredIndex = null;
    const focused = focusedIndex();
    activate(focused === -1 ? defaultIndex : focused, focused !== -1);
  });
  listen(group, 'focusout', () => {
    window.requestAnimationFrame(() => {
      if (group.contains(document.activeElement)) return;
      activate(hoveredIndex ?? defaultIndex, hoveredIndex !== null);
    });
  });
  listen(group, 'keydown', event => {
    if (event.key !== 'Escape') return;
    event.preventDefault();
    hoveredIndex = null;
    toggles[defaultIndex].focus({preventScroll:true});
    activate(defaultIndex, false);
    revealOnSmallScreen(cards[defaultIndex]);
  });

  function expandHashTarget() {
    let target;
    try { target = document.getElementById(decodeURIComponent(window.location.hash.slice(1))); }
    catch { return; }
    const index = cards.findIndex(card => card === target || (target && card.contains(target)));
    if (index !== -1) {
      activate(index);
      revealOnSmallScreen(cards[index]);
    }
  }
  group.setAttribute('data-help-enhanced', '');
  activate(defaultIndex, false);
  listen(window, 'hashchange', expandHashTarget);
  expandHashTarget();
  return { select(block) { const index = cards.indexOf(block); if (index >= 0) { activate(index); revealOnSmallScreen(block); } } };
}


function alignClimate(scope, listen, cleanup) {
  'use strict';
  const visual = scope.querySelector('#climate-solutions .climate-visual');
  if (!visual) return;
  const photo = visual.querySelector('.climate-photo-frame img');
  const sketch = visual.querySelector('.climate-sketch');
  if (!photo || !sketch) return;
  let scheduled = 0;

  function alignSketch() {
    scheduled = 0;
    const { width, height } = visual.getBoundingClientRect();
    const sourceWidth = photo.naturalWidth;
    const sourceHeight = photo.naturalHeight;
    if (!width || !height || !sourceWidth || !sourceHeight) return;

    const styles = getComputedStyle(photo);
    const zoom = parseFloat(styles.getPropertyValue('--climate-zoom')) || 1;
    const focus = styles.objectPosition.split(/\s+/).map(value => parseFloat(value) / 100);
    const cover = Math.max(width / sourceWidth, height / sourceHeight);
    const imageWidth = sourceWidth * cover;
    const imageHeight = sourceHeight * cover;
    const left = width + ((width - imageWidth) * focus[0] - width) * zoom;
    const top = height / 2 + ((height - imageHeight) * focus[1] - height / 2) * zoom;

    sketch.style.setProperty('--sketch-left', left + 'px');
    sketch.style.setProperty('--sketch-top', top + 'px');
    sketch.style.setProperty('--sketch-width', imageWidth * zoom + 'px');
    sketch.style.setProperty('--sketch-height', imageHeight * zoom + 'px');
    sketch.classList.add('is-aligned');
  }

  function scheduleAlignment() {
    if (!scheduled) scheduled = requestAnimationFrame(alignSketch);
  }

  listen(photo, 'load', scheduleAlignment);
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(scheduleAlignment);
    observer.observe(visual);
    cleanup.push(() => observer.disconnect());
  } else {
    listen(window, 'resize', scheduleAlignment, { passive: true });
  }
  scheduleAlignment();
  cleanup.push(() => cancelAnimationFrame(scheduled));
}
  function mount(scope) {
    if (instances.has(scope)) return;
    const abort = new AbortController(), cleanup = [];
    const listen = (target, type, handler, options = {}) => target?.addEventListener(type, handler, { ...options, signal: abort.signal });
    scope.classList.add('js');
    const language = () => scope.dataset.language === 'zh' ? 'zh' : 'en';
    scope.querySelectorAll('[data-aria-en][data-aria-zh]').forEach(el => el.setAttribute('aria-label', el.dataset[language() === 'zh' ? 'ariaZh' : 'ariaEn']));
    const gallery = createProjectCarousel(scope.querySelector('[data-project-gallery]'), language, listen, cleanup);
    const cards = createHelpCards(scope, listen, cleanup);
    alignClimate(scope, listen, cleanup);
    const hero = scope.querySelector('[data-hero-media]');
    if (hero) {
      const frame = requestAnimationFrame(() => hero.classList.add('is-ready'));
      cleanup.push(() => cancelAnimationFrame(frame));
    }
    const top = scope.querySelector('[data-back-to-top]');
    if (top) {
      const update = () => { top.hidden = scrollY <= 600; };
      listen(window, 'scroll', update, { passive: true });
      listen(top, 'click', () => {
        document.querySelector('#main-content')?.focus({ preventScroll: true });
        window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
      update();
    }
    listen(scope, 'click', event => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor || event.ctrlKey || event.metaKey || event.shiftKey) return;
      const target = document.getElementById(anchor.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      if (target.matches('[tabindex]')) target.focus({ preventScroll: true });
      history.replaceState(null, '', anchor.hash);
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    });
    listen(scope, 'shopify:block:select', event => {
      const block = event.target.closest('[data-home-block]');
      if (!block) return;
      if (block.matches('[data-help-card]')) cards?.select(block);
      if (block.matches('[data-project-slide]')) gallery.navigate?.([...scope.querySelectorAll('[data-project-slide]')].indexOf(block));
    });
    instances.set(scope, () => { abort.abort(); cleanup.forEach(dispose => dispose()); scope.classList.remove('js'); });
  }
  function mountAll(root) {
    if (root.matches?.('[data-home-section]')) mount(root);
    root.querySelectorAll('[data-home-section]').forEach(mount);
  }
  let headerFrame = 0;
  function updateHeader() {
    headerFrame = 0;
    const headers = [...document.querySelectorAll('.header-section, .section-header-mobile')];
    let bottom = 0;
    headers.forEach(header => {
      const style = getComputedStyle(header), rect = header.getBoundingClientRect();
      if (style.display !== 'none' && rect.width && rect.height && (style.position === 'sticky' || style.position === 'fixed' || header.classList.contains('shopify-section-header-sticky'))) bottom = Math.max(bottom, Math.max(0, rect.bottom));
    });
    document.querySelectorAll('[data-home-section]').forEach(scope => scope.style.setProperty('--lv-home-header-height', Math.round(bottom) + 'px'));
  }
  const scheduleHeader = () => { if (!headerFrame) headerFrame = requestAnimationFrame(updateHeader); };
  mountAll(document);
  updateHeader();
  window.addEventListener('resize', scheduleHeader, { passive: true });
  window.addEventListener('scroll', scheduleHeader, { passive: true });
  document.addEventListener('shopify:section:load', event => { mountAll(event.target); updateHeader(); });
  document.addEventListener('shopify:section:unload', event => {
    for (const [scope, dispose] of instances) if (event.target.contains(scope)) { dispose(); instances.delete(scope); }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["luvindow-home-video-v8"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lv-home-video')) {
  customElements.define('lv-home-video', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.trigger = this.querySelector('[data-video-open]');
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('[data-video-player]');
      this.template = this.querySelector('[data-video-template]');
      if (!this.trigger || !this.dialog || !this.template?.content.children.length) return;
      this.trigger.setAttribute('aria-haspopup', 'dialog');
      this.trigger.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !this.dialog.showModal) return;
        event.preventDefault();
        if (this.dialog.open) return;
        this.player.replaceChildren(this.template.content.cloneNode(true));
        this.dialog.showModal();
        document.documentElement.classList.add('lv-brand-video-open');
        this.player.querySelector('video')?.play().catch(() => {});
      }, { signal });
      this.querySelector('[data-video-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        this.stopVideo();
        this.trigger.focus({ preventScroll: true });
      }, { signal });
    }
    stopVideo() {
      this.player?.querySelectorAll('video').forEach(video => video.pause());
      this.player?.replaceChildren();
      if (!document.querySelector('.lv-brand-video__dialog[open]')) document.documentElement.classList.remove('lv-brand-video-open');
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.stopVideo();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
